import './wdyr'; // <--- first import
import { renderApp } from '@petconsole/pure-fe-mui';
import { App } from './app';
import store from './store/store';

renderApp({ App, store });
